import * as React from 'react';
import { Toast } from '../../components/Toast/index.js';
export var DisplayError = function (_a) {
    var error = _a.error;
    return error ? (React.createElement(Toast, { kind: "danger", icon: "fas fa-exclamation", title: "Error" },
        "That did not work. We encountered the following error: ",
        error.message)) : null;
};
//# sourceMappingURL=index.js.map